export function positivePackagingNumber(value) {
  const match = String(value == null ? '' : value).trim().match(/^\+?(\d+(?:[.,]\d+)?)/);
  if (!match) return null;
  const number = Number(match[1].replace(',', '.'));
  return Number.isFinite(number) && number > 0 ? number : null;
}

export function productPackaging(product, locale, palletFieldUuids = [], unitOverride = '') {
  if ((unitOverride || product.unit) !== 'm2') return {cartonSize: null, palletSize: null};
  const translation = (product.i18n || []).find(row => row.locale === locale) || {};
  const custom = product.custom_fields || product.data?.custom_fields || {};
  return {
    cartonSize: positivePackagingNumber(translation.packaging_content),
    palletSize: positivePackagingNumber(product.pallet_capacity) || palletFieldUuids.map(uuid => positivePackagingNumber(custom[uuid])).find(value => value != null) || null
  };
}

export function packagingCounts(quantity, packaging) {
  const amount = Number(quantity);
  if (!Number.isFinite(amount) || amount < 0) return {};
  const counts = {};
  if (packaging.cartonSize) counts.cartons = amount / packaging.cartonSize;
  if (packaging.palletSize) {
    const ratio = amount / packaging.palletSize;
    const integer = Math.round(ratio);
    counts.pallets = Math.ceil(Math.abs(ratio - integer) < 1e-10 ? integer : ratio);
  }
  return counts;
}

export function nextCartonQuantity(quantity, cartonSize, direction) {
  const amount = Number(quantity);
  if (!Number.isFinite(amount) || amount < 0 || !Number.isFinite(cartonSize) || cartonSize <= 0) return null;
  const ratio = amount / cartonSize;
  const integer = Math.round(ratio);
  const normalized = Math.abs(ratio - integer) < 1e-10 ? integer : ratio;
  const cartons = direction > 0 ? Math.floor(normalized) + 1 : Math.ceil(normalized) - 1;
  return Math.round(Math.max(0, cartons) * cartonSize * 1e8) / 1e8;
}
